(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8122],{

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 52933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ FormInput; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["register", "errorMessage", "defaultValue", "annotation", "as"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var FormInput = function FormInput(_ref) {
  var register = _ref.register,
      errorMessage = _ref.errorMessage,
      defaultValue = _ref.defaultValue,
      annotation = _ref.annotation,
      as = _ref.as,
      formInputProps = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Input, _objectSpread(_objectSpread(_objectSpread({}, formInputProps), register), {}, {
      defaultValue: defaultValue,
      as: as
    })), errorMessage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FormErrorMessage, {
      children: errorMessage.message
    }), annotation && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Annotation, {
      children: annotation
    })]
  });
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "enFormInput__Input",
  componentId: "sc-3mxh05-0"
})(["height:", ";border:1px solid #707070;padding:17px 20px 19px;width:100%;font-size:16px;letter-spacing:0.28px;resize:vertical;&::placeholder{color:", ";}@media screen and (max-width:1047px){max-width:none;}"], function (_ref2) {
  var as = _ref2.as;
  return as === 'textarea' ? '304px' : '56px';
}, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);
var Annotation = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "enFormInput__Annotation",
  componentId: "sc-3mxh05-1"
})(["font-size:12px;color:", ";margin-top:7px;&::before{content:'*';}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);
var FormErrorMessage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "enFormInput__FormErrorMessage",
  componentId: "sc-3mxh05-2"
})(["color:", ";font-size:12px;font-weight:bold;margin-top:5px;&::before{content:'*';}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.red */ .r.colors.red);

/***/ }),

/***/ 46107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FormLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var FormLabel = function FormLabel(_ref) {
  var text = _ref.text,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      inputId = _ref.inputId;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
    "data-required": isRequired,
    htmlFor: inputId,
    children: text
  });
};
var LabelField = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:14px;display:block;font-weight:normal;color:#fff;border-radius:4px;padding:0 14px;line-height:22px;margin-right:14px;letter-spacing:0.28px;white-space:nowrap;"]);
var Label = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
  displayName: "enFormLabel__Label",
  componentId: "sc-wu8meh-0"
})(["font-size:16px;font-weight:bold;line-height:26px;letter-spacing:0.32px;display:flex;align-items:baseline;&[data-required='true']{&::before{", ";content:'Required';background-color:", ";}}&[data-required='false']{&::before{", ";content:'Optional';background-color:", ";}}"], LabelField, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, LabelField, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey);

/***/ }),

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 85257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ irLabels; }
/* harmony export */ });
/* unused harmony export formData */
var irLabels = {
  company: {
    text: 'Company',
    isRequired: false,
    inputId: 'company'
  },
  fullName: {
    text: 'Name',
    isRequired: true,
    inputId: 'lastName'
  },
  firstName: {
    text: 'First name',
    isRequired: 'none',
    inputId: 'firstName'
  },
  lastName: {
    text: 'Last name',
    isRequired: 'none',
    inputId: 'lastName'
  },
  email: {
    text: 'Email Address',
    isRequired: true,
    inputId: 'email'
  },
  tel: {
    text: 'Phone Number',
    isRequired: false,
    inputId: 'tel'
  },
  title: {
    text: 'Subject',
    isRequired: false,
    inputId: 'title'
  },
  detail: {
    text: 'Message',
    isRequired: true,
    inputId: 'detail'
  }
};
var formData = {
  company: '',
  lastName: 'トライアル',
  firstName: '太郎',
  email: 'XXX@XXX.ne.jp',
  title: '件名が入りますダミー',
  detail: 'ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。'
};

/***/ }),

/***/ 73410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ IrPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/store/index.ts
var store = __webpack_require__(61268);
// EXTERNAL MODULE: ./src/store/contactIr/slice.ts
var slice = __webpack_require__(36170);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/enpages/Contact/ir/IrLabel.ts
var IrLabel = __webpack_require__(85257);
// EXTERNAL MODULE: ./src/components/elements/Button/index.tsx
var Button = __webpack_require__(96738);
// EXTERNAL MODULE: ./src/components/elements/enFormInput/index.tsx
var enFormInput = __webpack_require__(52933);
// EXTERNAL MODULE: ./src/components/elements/enFormLabel/index.tsx
var enFormLabel = __webpack_require__(46107);
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Contact/ir/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var IrPage = function IrPage() {
  var form = (0,store/* useSelector */.v9)(function (state) {
    return state.contactIr;
  });
  var dispatch = (0,store/* useDispatch */.I0)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var router = (0,next_router.useRouter)();

  var onSubmit = function onSubmit(data) {
    dispatch((0,slice/* setContactIr */.Jz)(data));
    router.push('/en/contact/ir/confirm');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Shareholders and Investors",
      description: "For inquiries about information for shareholders and investors.",
      ogp: {
        type: 'article',
        url: 'en/contact/ir/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(IRMain, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
        enTitleText: "Investors / Shareholders",
        subTitleText: "",
        color: "normal"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Note, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Inquiry form for IR (Shareholers and Investors information)."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: ["Before contacting us, please refer to the \"", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
            path: "/en/ir/faq",
            text: "Frequently Asked Questions"
          }), "\" section."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Please note that we cannot respond to inquiries other than those related to IR, so please understand in advance."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
        method: "post",
        noValidate: true,
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FormBackground, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FormMain, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(enFormLabel/* FormLabel */.l, _objectSpread({}, IrLabel/* irLabels.company */.O.company))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(enFormInput/* FormInput */.y, {
              id: "company",
              type: "text",
              register: register('company'),
              defaultValue: form.company
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(enFormLabel/* FormLabel */.l, _objectSpread({}, IrLabel/* irLabels.fullName */.O.fullName))
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormInner, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FormGroup, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(enFormLabel/* FormLabel */.l, _objectSpread({}, IrLabel/* irLabels.lastName */.O.lastName)), /*#__PURE__*/(0,jsx_runtime.jsx)(enFormInput/* FormInput */.y, {
                  id: "lastName",
                  type: "text",
                  register: register('lastName', {
                    required: {
                      value: true,
                      message: 'Please fill the required field.'
                    }
                  }),
                  errorMessage: errors.lastName,
                  defaultValue: form.lastName
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormGroup, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(enFormLabel/* FormLabel */.l, _objectSpread({}, IrLabel/* irLabels.firstName */.O.firstName)), /*#__PURE__*/(0,jsx_runtime.jsx)(enFormInput/* FormInput */.y, {
                  id: "firstName",
                  type: "text",
                  register: register('firstName', {
                    required: {
                      value: true,
                      message: 'Please fill the required field.'
                    }
                  }),
                  errorMessage: errors.firstName,
                  defaultValue: form.firstName
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(enFormLabel/* FormLabel */.l, _objectSpread({}, IrLabel/* irLabels.email */.O.email))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(enFormInput/* FormInput */.y, {
              id: "email",
              type: "email",
              register: register('email', {
                required: {
                  value: true,
                  message: 'Please fill the required field.'
                },
                pattern: {
                  message: 'Please enter correctly.',
                  value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                }
              }),
              placeholder: "e.g. XXX@XXX.ne.jp",
              errorMessage: errors.email,
              defaultValue: form.email
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(enFormLabel/* FormLabel */.l, _objectSpread({}, IrLabel/* irLabels.tel */.O.tel))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(enFormInput/* FormInput */.y, {
              id: "tel",
              type: "tel",
              maxLength: 13,
              register: register('tel', {
                pattern: {
                  message: 'Please enter correctly.',
                  value: /^[-0-9]+$/
                }
              }),
              placeholder: "e.g. 00-0000-0000",
              errorMessage: errors.tel,
              defaultValue: form.tel
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(enFormLabel/* FormLabel */.l, _objectSpread({}, IrLabel/* irLabels.title */.O.title))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(enFormInput/* FormInput */.y, {
              id: "title",
              type: "text",
              register: register('title'),
              placeholder: "e.g. Subject of the contents",
              defaultValue: form.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabelWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(enFormLabel/* FormLabel */.l, _objectSpread({}, IrLabel/* irLabels.detail */.O.detail))
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(enFormInput/* FormInput */.y, {
              id: "detail",
              type: "text",
              register: register('detail', {
                required: {
                  value: true,
                  message: 'Please fill the required field.'
                }
              }),
              as: "textarea",
              placeholder: "Please enter the detail of your inquiry.",
              errorMessage: errors.detail,
              defaultValue: form.detail
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormBottom, {
            children: ["Personal information acquired from this inquiry form is used solely for the purpose of responding to your inquiry.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "The Company properly handles personal informarion according to its ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
              path: "/en/legal/privacy-policy/",
              text: "Privacy Policy"
            }), "."]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubmitButton, {
            btnStyle: "outline",
            type: "submit",
            children: "Confirm"
          })
        })]
      })]
    })]
  });
};

IrPage.getLayout = function getLayout(page) {
  var pageTitle = {
    title: 'Inquiry',
    subTitle: ''
  };
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Inquiry',
    path: '/en/contact/'
  }, {
    name: 'Investors / Shareholders',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: true,
    children: page
  }));
};

var IRMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ir__IRMain",
  componentId: "sc-li5r5t-0"
})(["width:1040px;padding-bottom:130px;margin:78px auto 0;@media screen and (max-width:1047px){width:100%;margin:40px auto 0;padding:0 20px 70px;}"]);
var Note = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ir__Note",
  componentId: "sc-li5r5t-1"
})(["margin:71px 0 77px;p{line-height:30px;letter-spacing:0.32px;font-weight:400;}@media screen and (max-width:1047px){margin:56px 0 45px;p{font-size:15px;line-height:25px;letter-spacing:0.3px;}}"]);
var Form = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "ir__Form",
  componentId: "sc-li5r5t-2"
})([""]);
var FormMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ir__FormMain",
  componentId: "sc-li5r5t-3"
})(["display:grid;grid-template-columns:240px 1fr;gap:40px 30px;@media screen and (max-width:1047px){grid-template-columns:1fr;gap:16px 0;}"]);
var FormBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ir__FormBackground",
  componentId: "sc-li5r5t-4"
})(["background-color:", ";padding:86px 74px 99px;@media screen and (max-width:1047px){padding:27px 20px 40px;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var FormLabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ir__FormLabelWrapper",
  componentId: "sc-li5r5t-5"
})(["padding-top:14px;"]);
var FormInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ir__FormInner",
  componentId: "sc-li5r5t-6"
})(["display:flex;align-items:center;column-gap:43px;@media screen and (max-width:1047px){flex-direction:column;align-items:flex-start;row-gap:14px;}"]);
var FormGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ir__FormGroup",
  componentId: "sc-li5r5t-7"
})(["display:flex;align-items:center;column-gap:26px;width:50%;div{flex:1;}@media screen and (max-width:1047px){width:100%;}"]);
var FormBottom = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "ir__FormBottom",
  componentId: "sc-li5r5t-8"
})(["line-height:26px;letter-spacing:0.32px;margin-top:74px;font-weight:400;@media screen and (max-width:1047px){margin-top:36px;font-size:15px;line-height:25px;letter-spacing:0.3px;}"]);
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ir__ButtonWrapper",
  componentId: "sc-li5r5t-9"
})(["display:flex;justify-content:center;margin-top:107px;@media screen and (max-width:1047px){margin-top:54px;}"]);
var SubmitButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "ir__SubmitButton",
  componentId: "sc-li5r5t-10"
})(["width:198px;font-weight:400;border-width:1px;"]);
;// CONCATENATED MODULE: ./src/pages/en/contact/ir/index.tsx


/***/ }),

/***/ 28109:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/contact/ir",
      function () {
        return __webpack_require__(73410);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,825,4591,9774,2888,179], function() { return __webpack_exec__(28109); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);